import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M12 .75a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0V1.5A.75.75 0 0 1 12 .75" />
    <path fillRule="evenodd" d="M6 12a6 6 0 1 1 12 0 6 6 0 0 1-12 0m6-4.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9" clipRule="evenodd" />
    <path d="M5.03 3.97a.75.75 0 0 0-1.06 1.06l1.5 1.5a.75.75 0 0 0 1.06-1.06zM6.53 18.53l-1.5 1.5a.75.75 0 0 1-1.06-1.06l1.5-1.5a.75.75 0 0 1 1.06 1.06M18.53 6.53l1.5-1.5a.75.75 0 0 0-1.06-1.06l-1.5 1.5a.75.75 0 0 0 1.06 1.06M18.53 17.47l1.5 1.5a.75.75 0 1 1-1.06 1.06l-1.5-1.5a.75.75 0 1 1 1.06-1.06M1.5 11.25a.75.75 0 0 0 0 1.5h2.25a.75.75 0 0 0 0-1.5zM12 19.5a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0v-2.25a.75.75 0 0 1 .75-.75M20.25 11.25a.75.75 0 0 0 0 1.5h2.25a.75.75 0 0 0 0-1.5z" />
  </>
);

const Sun = Icon('sun', svgContents);

export default Sun;
